(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  if (customElements.get('sd-sales-countdown')) return;

  // Interpret the merchant's wall-clock date in a named time zone, independently
  // of the shopper's device zone. Reject invalid or ambiguous DST clock times.
  function deadline(date, time, zone) {
    if (!/^\d{2}:\d{2}$/.test(time)) return NaN;
    // Accept the previous format too, so saved timers keep their deadline.
    const usDate = /^(\d{2})-(\d{2})-(\d{4})$/.exec(date);
    const legacyDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
    if (!usDate && !legacyDate) return NaN;
    const [year, month, day] = usDate
      ? [Number(usDate[3]), Number(usDate[1]), Number(usDate[2])]
      : legacyDate.slice(1).map(Number);
    const [hour, minute] = time.split(':').map(Number);
    const wall = Date.UTC(year, month - 1, day, hour, minute);
    const check = new Date(wall);
    if (year < 2000 || year > 2100 || check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day || hour > 23 || minute > 59) return NaN;
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const partsAt = stamp => Object.fromEntries(formatter.formatToParts(new Date(stamp)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
      const offsets = new Set();
      for (const delta of [-86400000, 0, 86400000]) {
        const stamp = wall + delta;
        const p = partsAt(stamp);
        offsets.add(Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - stamp);
      }
      const matches = [...offsets].map(offset => wall - offset).filter(stamp => {
        const p = partsAt(stamp);
        return p.year === year && p.month === month && p.day === day && p.hour === hour && p.minute === minute;
      });
      return matches.length === 1 ? matches[0] : NaN;
    } catch (_) { return NaN; }
  }

  class SalesCountdown extends HTMLElement {
    connectedCallback() {
      // Allow descendants to finish parsing when inserted after definition.
      clearTimeout(this.setupTimer);
      this.setupTimer = setTimeout(() => this.setup(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this.setupTimer);
      clearInterval(this.timer);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
    setup() {
      this.disconnectedCallback();
      this.active = this.querySelector('[data-sc-active]');
      this.ended = this.querySelector('[data-sc-ended]');
      this.notice = this.querySelector('[data-sc-notice]');
      if (!this.active || !this.ended || !this.notice) return;
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-sc-${unit}]`));
      this.editor = this.dataset.editor === 'true';
      this.active.hidden = false;
      this.ended.hidden = true;
      this.notice.hidden = true;
      this.hidden = true;
      if (this.dataset.eligible !== 'true') {
        this.showNotice('Hidden on this product. Enable the block and choose All products, or add this product to Selected products.');
        return;
      }
      this.end = deadline(this.dataset.date, this.dataset.time, this.dataset.zone);
      if (!Number.isFinite(this.end)) {
        this.showNotice('Set a valid end date (MM-DD-YYYY), time (HH:MM), and time zone. Avoid the skipped or repeated hour when daylight saving time changes. Hidden from customers until configured.');
        return;
      }
      this.start = null;
      const startDate = (this.dataset.startDate || '').trim();
      if (startDate) {
        this.start = deadline(startDate, (this.dataset.startTime || '').trim(), this.dataset.zone);
        if (!Number.isFinite(this.start)) {
          this.showNotice('Set a valid start date (MM-DD-YYYY) and time (HH:MM), or clear the start date to show the block immediately. Avoid the skipped or repeated hour when daylight saving time changes.');
          return;
        }
        if (this.start >= this.end) {
          this.showNotice('The sale start must be before the end date and time. Hidden from customers until corrected.');
          return;
        }
      }
      this.tick();
      if (this.end > Date.now()) {
        this.timer = setInterval(() => this.tick(), 1000);
        this.onVisibility = () => { if (!document.hidden) this.tick(); };
        document.addEventListener('visibilitychange', this.onVisibility);
      }
    }
    showNotice(message) {
      if (!this.editor) return;
      this.hidden = false;
      this.active.hidden = true;
      this.ended.hidden = true;
      this.notice.textContent = message;
      this.notice.hidden = false;
    }
    tick() {
      const now = Date.now();
      if (this.start !== null && now < this.start) {
        this.hidden = true;
        this.active.hidden = true;
        this.ended.hidden = true;
        this.notice.hidden = true;
        this.showNotice(`Scheduled to start ${this.dataset.startDate} at ${this.dataset.startTime} (${this.dataset.zone}). Hidden from customers until then.`);
        return;
      }
      this.notice.hidden = true;
      this.active.hidden = false;
      this.ended.hidden = true;
      const seconds = Math.max(0, Math.ceil((this.end - now) / 1000));
      if (seconds === 0) {
        clearInterval(this.timer);
        if (this.dataset.expiry === 'message') {
          this.hidden = false;
          this.active.hidden = true;
          this.ended.hidden = false;
        } else {
          this.hidden = true;
          this.fields.forEach(el => { el.textContent = '00'; });
          this.showNotice('This sale has ended. The block is hidden from customers. Set a future end date to show it again.');
        }
        return;
      }
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      this.fields.forEach((el, index) => {
        const next = String(values[index]).padStart(2, '0');
        if (el.textContent !== next) el.textContent = next;
      });
      this.hidden = false;
    }
  }
  customElements.define('sd-sales-countdown', SalesCountdown);
})();

  } catch(e) { console.error(e); }
})();
})();
